<template>
  <div :class="['mine-menu', { disabled: isDisabled }]">
    <router-link :to="{ path: '/mine' }" target="_blank" :class="{ disabled: isDisabled }" rel="noopener noreferrer"  @click.native="onClickMineLink">
      <svg class="min-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
        <g clip-path="url(#clip0_353_40877)">
          <path d="M0.800537 10.4552C5.08709 10.4817 7.76419 10.4339 12.0561 10.4498C14.271 10.4605 14.8766 10.4445 19.0994 10.418" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.84009 2.70151C6.99944 2.61652 8.17864 2.31906 8.24238 2.31906C8.33268 2.31906 9.73497 1.09206 10.2183 0.789292C10.2343 0.778668 10.8292 1.13986 11.2222 1.39483C12.0987 1.96318 12.6936 2.5156 12.7148 2.52091C12.7733 2.53684 13.8675 5.20332 13.9418 5.26706C14.2499 5.51671 14.8183 5.86729 15.785 6.61093C15.8116 6.63217 16.2365 9.049 16.4012 10.1591" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.71826 10.1693C2.89355 9.20252 3.2335 7.79492 3.24412 7.58245C3.24412 7.49215 4.6836 6.67946 4.84826 6.61041C4.89606 6.58916 5.96386 4.07589 5.97448 4.00684" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.13721 7.04169C7.27434 6.89884 8.45478 5.85125 8.45478 5.85125C8.51763 5.80554 9.74037 4.81706 9.87179 4.8342C9.96321 4.84563 11.963 5.90839 12.7629 6.69689C12.9001 6.8283 13.6429 9.78231 13.66 10.0451" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.13599 8.04105L8.4552 7.74939C8.51805 7.70368 9.75222 6.68092 9.87221 6.73234C9.9522 6.76663 11.0949 7.36086 11.9177 8.02937C12.0377 8.1265 12.5062 9.56065 12.6948 10.0806" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.8064 9.45446C9.11494 9.20877 9.76529 8.48316 9.87385 8.5003C9.96527 8.51173 10.4852 8.7917 11.3994 9.45449C11.4394 9.48306 11.8021 9.90545 11.9678 10.334" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.57487 10.3279C8.26148 9.80208 7.90559 9.30278 7.51253 8.83535C7.4541 8.7663 7.39036 8.69725 7.31599 8.64944C7.21507 8.5857 7.0929 8.57508 6.97073 8.55914C6.48737 8.50603 5.99869 8.46884 5.51001 8.4476C5.41971 8.4476 5.32941 8.44229 5.24974 8.47416C5.15413 8.51134 5.08507 8.59633 5.02133 8.676C4.63889 9.15406 4.27769 9.64804 3.93774 10.158" stroke="#0085FF" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_353_40877">
            <rect width="19.9335" height="11.1393" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      Mine
      <template v-if="!isDisabled">
        <i class="icon icon--mine-link move-link" />
      </template>
    </router-link>
    <ui-icon-tooltip
      v-if="isDisabled"
      iconSize="14"
      arrowTop arrowCenter>
      <span class="link-text" v-html="$t('mine.tooltip.link')"></span>
    </ui-icon-tooltip>
  </div>
</template>
<script>
import UiIconTooltip from '@/components/ui/UiIconTooltip.vue'

export default {
  name: 'MineButton',
  components: { UiIconTooltip },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickMineLink (e) {
      if (this.isDisabled) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.mine-menu {
  margin-top: 79px;
  position: relative;
  padding: 16px 18px 16px 10px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-top: 1px solid #BBB;

  &:hover:not(.disabled) {
    background: #EFF7FF;

  }

  & /deep/ {
    .tooltip {
      height: 14px;
    }

    .bubble {
      width: 220px;
      padding: 16px 20px;

      .text {
        line-height: 1.5;
        white-space: initial;
        text-align: left;
      }
    }
  }

  .tooltip {
    margin-left: auto;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    color: #0074FF;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
    flex: auto;

    &.disabled {
      opacity: 0.3;
      pointer-events: none;
      cursor: not-allowed;
    }

    .move-link {
      margin-left: auto;
    }
  }
}
</style>
